/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Inbound_Waiting_On_Tomorrow_DispatchInputs */

const en_inbound_waiting_on_tomorrow_dispatch = /** @type {(inputs: Inbound_Waiting_On_Tomorrow_DispatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Tomorrow · send to the warehouse · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Tomorrow · send to the warehouse · since {since}" |
*
* @param {Inbound_Waiting_On_Tomorrow_DispatchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_tomorrow_dispatch = /** @type {((inputs: Inbound_Waiting_On_Tomorrow_DispatchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_Tomorrow_DispatchInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_tomorrow_dispatch(inputs)
});